/**
 * late-apps.js
 * Laadt scripts van derden pas als de bezoeker iets doet, in plaats van meteen.
 * Toegevoegd 2 aug 2026; Clarity erbij op 23 okt 2026 (V131)
 *
 * WAAROM
 * ------
 * PageSpeed rekent je score uit door je pagina op een trage 4G-verbinding te
 * simuleren. Alles wat tijdens het laden binnenkomt, staat daar in dezelfde
 * wachtrij - ook scripts die pas veel later iets nuttigs doen. Klaviyo haalt
 * 13 bestanden en zo'n 78 KB binnen om gedrag te meten dat nog moet gebeuren.
 *
 * Dit bestand laadt die scripts pas bij de eerste scroll, tik of toetsaanslag.
 * Op dat moment is de pagina al zichtbaar en is de meting voorbij.
 *
 * WAT DIT KOST
 * ------------
 * Wees eerlijk over de keerzijde: een bezoeker die binnenkomt, niets doet en
 * weer wegklikt binnen de terugvaltijd hieronder, wordt niet meer geteld.
 * Voor de flows die daadwerkelijk in gebruik zijn - add-to-cart-mails en
 * bedankmails na een bestelling - verandert er niets, want daar moet de
 * bezoeker sowieso iets voor doen.
 *
 * De terugval van 7 seconden zorgt dat een rustig lezende bezoeker alsnog
 * geteld wordt.
 *
 * V145 (26 okt 2026): terugval van 7 naar 12 seconden na het load-event.
 * Lighthouse meet op een gesimuleerde trage telefoon door tot de pagina
 * stil is; met 7 s vielen Klaviyo's 13 bestanden (ruim 300 KB) nog binnen
 * die meting en verlengden ze de "tijd tot interactief". Een echte bezoeker
 * scrolt of tikt vrijwel altijd binnen een paar seconden en laadt Klaviyo
 * dus gewoon via de signalen hierboven; alleen wie 12 s stilstaand kijkt
 * en dan weggaat, wordt niet meer geteld.
 */
(function () {
  'use strict';

  var KLAVIYO_ID = 'UXRbTc';
  var TERUGVAL_MS = 12000;

  var geladen = false;
  var timer = null;

  var signalen = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll', 'mousemove'];

  function laadScript(src, attrs) {
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    if (attrs) {
      Object.keys(attrs).forEach(function (k) { s.setAttribute(k, attrs[k]); });
    }
    document.head.appendChild(s);
    return s;
  }

  function start() {
    if (geladen) return;
    geladen = true;

    signalen.forEach(function (naam) {
      window.removeEventListener(naam, start, true);
    });
    if (timer) { clearTimeout(timer); timer = null; }

    /*
      Klaviyo verwacht dat window._learnq bestaat voordat zijn script laadt.
      Bestellingen die vóór dit moment in de wachtrij zijn gezet - bijvoorbeeld
      door een ander script - worden dan alsnog netjes afgehandeld.
    */
    window._learnq = window._learnq || [];

    laadScript('https://static.klaviyo.com/onsite/js/' + KLAVIYO_ID + '/klaviyo.js');

    laadClarity();

    document.dispatchEvent(new CustomEvent('late-apps:geladen'));
  }

  /*
    V131 (23 okt 2026): Microsoft Clarity gaat dezelfde weg als Klaviyo.
    De app-embed van Clarity staat daarom UIT in de theme-instellingen
    (config/settings_data.json, blok microsoft-clarity/clarity_js); zet je
    die weer aan, dan laadt Clarity twee keer. Dit is Clarity's eigen
    Shopify-snippet, inclusief de koppeling met Shopify's cookie-consent,
    alleen later gestart. Opnames beginnen dus bij de eerste scroll of tik
    (of na 7 s); de eerste seconde stilstaand kijken ontbreekt in de
    opname, de rest niet. Lighthouse mat Clarity op 29 KB en 177 ms
    rekenwerk op de hoofdthread, precies in de seconden waarin de
    productfoto moet binnenkomen.
  */
  var CLARITY_ID = 'z1rizyqous';

  function laadClarity() {
    var c = window, l = document, a = 'clarity';
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    laadScript('https://www.clarity.ms/tag/' + CLARITY_ID + '?ref=shopify');

    function consent(marketing, analytics) {
      c[a]('consentv2', {
        ad_Storage: marketing ? 'granted' : 'denied',
        analytics_Storage: analytics ? 'granted' : 'denied',
        source: 101
      });
    }
    if (c.Shopify && typeof c.Shopify.loadFeatures === 'function') {
      c.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) { if (c.console) console.error('Error loading Shopify features:', error); return; }
        var cp = c.Shopify.customerPrivacy;
        consent(cp.marketingAllowed(), cp.analyticsProcessingAllowed());
      });
    }
    l.addEventListener('visitorConsentCollected', function (e) {
      consent(e.detail.marketingAllowed, e.detail.analyticsAllowed);
    });
  }

  signalen.forEach(function (naam) {
    window.addEventListener(naam, start, { capture: true, passive: true, once: true });
  });

  /* Terugval: ook zonder interactie uiteindelijk laden. */
  function zetTerugval() {
    timer = setTimeout(start, TERUGVAL_MS);
  }

  if (document.readyState === 'complete') {
    zetTerugval();
  } else {
    window.addEventListener('load', zetTerugval, { once: true });
  }
})();
